import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
//import {} from '@learningblocks/protocol-redux/lib/Actions';


function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].type,
    volume: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].volume,
    pour: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].pour
  }
}

function mapDispatchToProps(dispatch) {

  return {};
}
export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);